/**
 * secretariatRoutes.jsx — Routes du back-office Secrétariat (/secretariat/*)
 * Rôles autorisés : secretaire | admin.
 */
import React from 'react';
import { Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from '../components/ProtectedRoute';
import SecretariatLayout from '../components/SecretariatLayout';
import SecretariatDashboard from '../pages/secretariat/DashboardPage';
import SecretariatPlanning from '../pages/secretariat/PlanningPage';
import SecretariatEleves from '../pages/secretariat/ElevesPage';
import SecretariatEnseignants from '../pages/secretariat/EnseignantsPage';
import SecretariatFormules from '../pages/secretariat/FormulesPage';
import SecretariatStats from '../pages/secretariat/StatsPage';

export const SecretariatRoutes = () => (
  <Route path="/secretariat" element={
    <ProtectedRoute roles={['secretaire', 'admin']}>
      <SecretariatLayout />
    </ProtectedRoute>
  }>
    <Route index element={<Navigate to="/secretariat/dashboard" replace />} />
    <Route path="dashboard" element={<SecretariatDashboard />} />
    <Route path="planning" element={<SecretariatPlanning />} />
    <Route path="eleves" element={<SecretariatEleves />} />
    <Route path="enseignants" element={<SecretariatEnseignants />} />
    <Route path="formules" element={<SecretariatFormules />} />
    <Route path="stats" element={<SecretariatStats />} />
  </Route>
);

export default SecretariatRoutes;
